import { render, staticRenderFns } from "./bottom-navigation.vue?vue&type=template&id=2372104c&scoped=true&"
import script from "./bottom-navigation.ts?vue&type=script&lang=ts&"
export * from "./bottom-navigation.ts?vue&type=script&lang=ts&"
import style0 from "./bottom-navigation.scss?vue&type=style&index=0&id=2372104c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2372104c",
  null
  
)

component.options.__file = "bottom-navigation.vue"
export default component.exports